import { render, staticRenderFns } from "./Inboxes.vue?vue&type=template&id=e2dce4e8&scoped=true&"
import script from "./Inboxes.vue?vue&type=script&lang=js&"
export * from "./Inboxes.vue?vue&type=script&lang=js&"
import style0 from "./Inboxes.vue?vue&type=style&index=0&id=e2dce4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dce4e8",
  null
  
)

export default component.exports